
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.6 0H1.132A1.132 1.132 0 000 1.129v1.038a1.126 1.126 0 00.8 1.086v6.145a1.29 1.29 0 001.3 1.28h4.427v1.2l-1.969 1.517a.334.334 0 10.408.529l1.882-1.447 1.9 1.45a.33.33 0 00.2.071.347.347 0 00.268-.131.332.332 0 00-.064-.469l-1.959-1.49v-1.226h4.411a1.273 1.273 0 001.283-1.279V3.267a1.112 1.112 0 00.838-1.089V1.133A1.132 1.132 0 0012.6 0zm-.988 10.014H2.104a.621.621 0 01-.63-.61V3.315h10.751v6.089a.606.606 0 01-.613.61zm1.45-7.831a.463.463 0 01-.462.463H1.132a.463.463 0 01-.463-.463V1.131a.463.463 0 01.463-.462H12.6a.463.463 0 01.462.462z"}}),_c('path',{attrs:{"d":"M7.693 6.745l-.492.459V5.425a.335.335 0 00-.67 0v1.779l-.492-.456a.334.334 0 10-.456.489l1.055.982a.332.332 0 00.456 0l1.055-.982a.335.335 0 00-.456-.492z"}})])
          )
        }
      }
    